/** @module Apparel/MassCopyStylesForm */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/def",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/form/Widget",
	"csi/locale",
	"csi/store/_base",
    "csi/store/Names",
    "csi/xml",
	"csi/xml/Query"
], function(declare,lang,_,def,Action,ViewRef,Widget,locale,csiStore,Names,xml,Query) {

	return declare(Widget,{

		/**
		* Modified the form view
		*/
		_resolveView: function() {
			this.addFixedValue("ToSeason", this.urlRoot);
			this.inherited(arguments);
		},

		/**
		* Modified the store for field to display custom dropdown values
		* @param {Field} field- field on the form
		* @parma {string} value - value of the field
		* @return {Store} - the store for field
		*/
		getFieldStore: function(field, value) {
			var q = new Query();
			var selectedSeason = this.defView.getFieldValue("FromSeason");
			var selectedCat1 = this.defView.getFieldValue("FromCat1");
			var selectedCat2 = this.defView.getFieldValue("FromCat2");
			if(field.getControlName() == "StyleCopyTemplates") {
				// modify the store options with callback function
				var storeOptions = csiStore.namesOptionsByRelationship(this.getContext(), field.m_relationship, {
					customOperation: true,
					_processResultNode: function(/*Node*/node, /*Cache*/cache){
						return {$:node.$URL, Name:node.$Name+" - "+node.RootSubTypeName, node:node};
				}});
				storeOptions.action = lang.mixin(new Action(),{
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: "CopyTemplates",
						m_url: "centric://SITEADMIN/_CS_Site"
					})
				});
				return new Names(storeOptions);
			}
			if(field.getControlName() == "FromCat1") {
				q.RefAttr("ParentSeason", xml.OP_EQUALS, selectedSeason);
				field.m_relationship.addQuery(q, true);
			}
			if(field.getControlName() == "FromCat2") {
				q.RefAttr("Category1", xml.OP_EQUALS, selectedCat1);
				field.m_relationship.addQuery(q, true);
			}
			if(field.getControlName() == "FromColl") {
				q.RefAttr("Category2", xml.OP_EQUALS, selectedCat2);
				field.m_relationship.addQuery(q, true);
			}
			return this.inherited(arguments);
		}

	});

});
